import React, { useEffect, useState } from 'react';
import { Box, Modal, TextField, Button, CircularProgress, MenuItem } from '@mui/material';
import cancelHover from '../../assets/icons/delete (6) 1.png';
import cancel from '../../assets/icons/delete (7) 1.png';
import useAdvertiser from './useAdvertiser';

const ArchiveModal = ({ openArchivedModal, handleClose }) => {
  const { advertiserApiCall } = useAdvertiser(handleClose);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null); // full object

  useEffect(() => {
    if (openArchivedModal?.data) {
      setData(openArchivedModal?.data);
    } else {
      setData(null);
    }
  }, [openArchivedModal]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data) return;
    setLoading(true);

    const payload = {
      ...data,
      archived: !data?.archived, // only toggle archived
    };

    await advertiserApiCall(payload, data?.id);
    setLoading(false);
    window.location.reload();
  };

  const oppositeOption = data?.archived ? 'Unarchive' : 'Archive';

  return (
    <Modal
      BackdropProps={{ sx: { backgroundColor: '#EEEEEE' } }}
      open={openArchivedModal?.open}
      onClose={handleClose}
    >
      <Box
        className="border"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          height: '100%',
          boxShadow: 24,
          px: 24,
          py: 8,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 90,
            right: 226,
            cursor: 'pointer',
          }}
        >
          <img
            src={cancel}
            alt="cancel"
            onMouseOver={(e) => (e.currentTarget.src = cancelHover)}
            onMouseOut={(e) => (e.currentTarget.src = cancel)}
            onClick={handleClose}
          />
        </Box>

        <Box sx={{ border: '1px solid #1C4645', p: 10, borderRadius: 10 }}>
          <form onSubmit={handleSubmit}>
            {/* Advertiser Name */}
            <Box sx={{ border: '1px solid #ccc', px: 4, py: 4 }}>
              <TextField
                label="Advertiser Name"
                value={data?.advertiserName || ''}
                fullWidth
                disabled
              />
            </Box>

            {/* Archived Action */}
            <Box sx={{ border: '1px solid #ccc', px: 4, py: 4 }}>
              <TextField
                label={`Do you want to ${oppositeOption.toLowerCase()} this advertiser?`}
                value={oppositeOption}
                select
                fullWidth
              >
                <MenuItem value={oppositeOption}>{oppositeOption}</MenuItem>
              </TextField>
            </Box>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 4, mt: 8 }}>
              <Button
                variant="outlined"
                onClick={handleClose}
                sx={{
                  borderColor: '#1C4645',
                  color: '#1C4645',
                  '&:hover': {
                    backgroundColor: '#1C4645',
                    color: 'white',
                    borderColor: '#1C4645',
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="outlined"
                disabled={loading}
                sx={{
                  backgroundColor: '#1C4645',
                  color: 'white',
                  ml: 2,
                  '&:hover': {
                    backgroundColor: 'white',
                    borderColor: '#1C4645',
                    color: '#1C4645',
                  },
                }}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" sx={{ color: 'white' }} />
                ) : (
                  'Submit'
                )}
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
    </Modal>
  );
};

export default ArchiveModal;
